import React from 'react';
import bem from '../../../lib/bemUtils/bem';
import { Modifier, appendModifiers } from '../../../lib/bemUtils/Modifier';

export enum StateIndicatorModifier {
  FLYOUT_NAVIGATION_ITEM = 'flyout-navigation-item',
  MAIN_NAVIGATION_ITEM = 'main-navigation-item',
  INLINE_BLOCK = 'inline-block',
  NO_MARGIN_RIGHT = 'no-margin-right',
  BORDER = 'border',
}

export type StateIndicator = {
  status: 'red' | 'green' | 'yellow' | 'purple';
  modifier?: Modifier<StateIndicatorModifier>;
};

export function StateIndicator({ status, modifier }: StateIndicator) {
  return <span className={bem('state-indicator', appendModifiers(status as StateIndicatorModifier, modifier))} />;
}
